import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_MOCK_DETAIL } from '../../Utils/apis';
import { addMockDetail } from '../../Store/Slices/mocks';

const useFetchMockDetail = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const dispatch = useDispatch();

    const fetchMockDetail = async (mockId) => {
        try {
            setLoading(true);
            setError('');
            const res = await fetch(`${FETCH_MOCK_DETAIL}/${mockId}`, {
                method: 'GET',
                credentials: 'include',
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.message || 'Failed to fetch mock detail');
            }
            const data = await res.json();
            dispatch(addMockDetail(data?.data?.mockInterviewData));
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return [loading, error, fetchMockDetail];
};

export default useFetchMockDetail;
